import script from "./expanded-comment-card.vue?vue&type=script&setup=true&lang=js"
export * from "./expanded-comment-card.vue?vue&type=script&setup=true&lang=js"

import "./expanded-comment-card.vue?vue&type=style&index=0&id=d90a29ac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d90a29ac"]])

export default __exports__